import { render, staticRenderFns } from "./AdvancedLaravelVuePaginate.vue?vue&type=template&id=08078ab7&scoped=true&"
import script from "./AdvancedLaravelVuePaginate.vue?vue&type=script&lang=js&"
export * from "./AdvancedLaravelVuePaginate.vue?vue&type=script&lang=js&"
import style0 from "./AdvancedLaravelVuePaginate.vue?vue&type=style&index=0&id=08078ab7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08078ab7",
  null
  
)

export default component.exports